import { useFlags } from "@aichat/aichat-lib";
import { DigitalHumanProps } from "@aichat/types/widget";
import { FlagsmithTraits } from "@aichat/types/index";
import { lazy } from "react";

const AkoolAvatar = lazy(() => import("./AkoolAvatar"));
const HeygenAvatar = lazy(() => import("./HeygenAvatar"));

export default function DigitalHumanAvatar(props: DigitalHumanProps) {
  const {
    enable_akool,
    akool_avatar_id,
    akool_voice_id,
    heygen_avatar_name,
    heygen_voice_id,
    heygen_avatar_slug,
  } = useFlags(
    [],
    [
      FlagsmithTraits.ENABLE_AKOOL,
      FlagsmithTraits.AKOOL_AVATAR_ID,
      FlagsmithTraits.AKOOL_VOICE_ID,
      FlagsmithTraits.HEYGEN_AVATAR_NAME,
      FlagsmithTraits.HEYGEN_VOICE_ID,
      FlagsmithTraits.HEYGEN_AVATAR_SLUG,
    ],
  );

  if (enable_akool && akool_avatar_id && akool_voice_id)
    return (
      <AkoolAvatar
        avatarId={akool_avatar_id as string}
        voiceId={akool_voice_id as string}
        {...props}
      />
    );
  return (
    <HeygenAvatar
      heygenAvatarName={heygen_avatar_name as string}
      heygenVoiceId={heygen_voice_id as string}
      heygenAvatarSlug={heygen_avatar_slug as string}
      {...props}
    />
  );
}
